import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Organization} from '../organization';
import {OrganizationService} from '../organization.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {appConfig} from "../../../../app.config";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {UserPictureComponent} from "../../../../components/user-picture";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {ItemsGroupsShowComponent} from "../../itemsGroups/itemsGroups-show/itemsGroups-show.component";
import {CurrenciesShowComponent} from "../../currencies/currencies-show/currencies-show.component";
import {EmployeesShowComponent} from "../../employees/employees-show/employees-show.component";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";


@NgModule({
    imports: [CommonModule, FormsModule, DropdownModule, MessagesModule,MyInputsModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        OrganizationShowComponent
    ],
    entryComponents: [
        OrganizationShowComponent
    ],
    exports: [],
    providers: [SharedService, OrganizationService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-organization-show',
    templateUrl: './organization-show.component.html',
    styleUrls: ['./organization-show.component.scss'],
    providers: [OrganizationService, ConfirmationService, MessageService]
})

export class OrganizationShowComponent implements OnInit, AfterViewInit {
    id: string;
    organization =  new Organization();
    @Input() refShow;
    currency: any[] = [];
    // picture:string;x
    applog: AppLogComponent;
    parent_name: any;
    @Input() scrId;
    modalRef: NgbModalRef;
    parent:any;
    @Input() delId;
    @Input() oldData;
    @Input() newData;
    @Input() newDatap;
    @Input() modelName;
    statusVal = [{'val': 1, 'title': 'Yes'}, {'val': 2, 'title': 'No'}];
    defVal = [{'val': 1, 'title': 'Yes'}, {'val': 0, 'title': 'No'}];

    form: FormGroup;
    private sub: any;
    msgs: Message[] = [];
    public imgUrl = appConfig.publicUrl;
    private _editButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private organizationService: OrganizationService,
                private modalService: NgbModal,
                public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        this.msgs =[];

        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            // {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},

        ]);
        this.sharedservice.setModelName('organization');
      this.sharedservice.setItemShow(OrganizationShowComponent);

    }
    showParent(){
        if(this.parent) {
            const options: NgbModalOptions = {

                beforeDismiss: () => {
                    console.log("before dismiss");
                    return true;
                }
            };
            this.modalRef = this.modalService.open(CurrenciesShowComponent, options);
            this.modalRef.componentInstance.scrId = this.parent;

            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }
    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.organization;
        modalRef.componentInstance.rowId = '';

    }

    ngAfterViewInit() {
        if(!this.scrId) {
            this._editButton = document.getElementById('editButton');
            this._deleteButton = document.getElementById('deleteButton');
            this._newButton = document.getElementById('newButton');
            this._printButton = document.getElementById('printButton');
            this._searchButton = document.getElementById('searchButton');


            if (this._editButton) {
                this._editButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/organization/edit', this.id]);
                });
            }
            if (this._deleteButton) {

                this._deleteButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.deleteOrganization(this.organization);
                });
            }
            if (this._newButton) {

                this._newButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/organization']);
                });

            }
            if (this._searchButton) {
                this._searchButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/organization/search']);
                });
            }
        }
    }

    ngOnInit() {
        this.msgs =[];

        this.organizationService.getAllCurrencies().subscribe(
            currency => {
                this.currency = currency;
            });
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
            this.parent_name = params['organization_parent_group'];


        });

        this.form = new FormGroup({
            id: new FormControl({value: '', disabled: true}),
            name: new FormControl({value: '', disabled: true}),
            name_en: new FormControl({value: '', disabled: true}),
            vat_sts: new FormControl({value: '', disabled: true}),
            def_org: new FormControl({value: '', disabled: true}),
            tax_number: new FormControl({value: '', disabled: true}),
            main_currency: new FormControl({value: '', disabled: true}),
            address: new FormControl({value: '', disabled: true}),
            address_en: new FormControl({value: '', disabled: true}),
            telephone: new FormControl({value: '', disabled: true}),
            fax: new FormControl({value: '', disabled: true}),
            email: new FormControl({value: '', disabled: true}),
            website: new FormControl({value: '', disabled: true}),
            system_logo:new FormControl({value: '', disabled: true}),
            reports_logo: new FormControl({value: '', disabled: true})

        });

        if (this.id) {
            this.msgs =[];

            this.activeModal.dismiss('');
            this.oldData = false;
            this.newData = false;
            this.delId = false;
          this.newDatap = true;
            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if (msg) {
                localStorage.removeItem('showMessages');
                this.msgs = msg;
            }
            this.organizationService.getById(this.id).subscribe(
                organization => {
                    this.id = organization.id;
                    this.organization = organization;
                    this.parent = organization.main_currency;
                    this.form.patchValue({
                        id: organization.id,
                        name: organization.name,
                        name_en: organization.name_en,
                        vat_sts: organization.vat_sts,
                        def_org: organization.def_org+'',
                        tax_number: organization.tax_number,
                        main_currency: organization.main_currency,
                        address: organization.address,
                        address_en: organization.address_en,
                        telephone:organization.tel,
                        fax:organization.fax,
                        email: organization.email,
                        website: organization.website,
                        system_logo: organization.system_logo,
                        reports_logo: organization.reports_logo,

                    });
                }, error => {
                    console.log(error);
                }
            );


        }
        if (this.scrId) {
            this.oldData = false;
            this.newData = false;
            this.delId = false;

            this.organizationService.getById(this.scrId).subscribe(
                organization => {
                    this.id = organization.id;
                    this.organization = organization;
                    this.parent = organization.main_currency;
                    this.form.patchValue({
                        id: organization.id,
                        name: organization.name,
                        name_en: organization.name_en,
                        vat_sts: organization.vat_sts,
                        def_org: organization.def_org+'',
                        tax_number: organization.tax_number,
                        main_currency: organization.main_currency,
                        address: organization.address,
                        address_en: organization.address_en,
                        telephone:organization.tel,
                        fax:organization.fax,
                        email: organization.email,
                        website: organization.website,
                        system_logo: organization.system_logo,
                        reports_logo: organization.reports_logo,

                    });
                }, error => {
                    console.log(error);
                }
            );


        }
        if (this.delId) {
            this.oldData = false;
            this.newData = false;
            this.newDatap = !this.newDatap ;
            this.organizationService.getTrashedById(this.delId).subscribe(
                organization => {
                    this.id = organization.id;
                    this.organization = organization;
                    this.form.patchValue({
                        id: organization.id,
                        name: organization.name,
                        name_en: organization.name_en,
                        vat_sts: organization.vat_sts,
                        def_org: organization.def_org+'',
                        tax_number: organization.tax_number,
                        main_currency: organization.main_currency,
                        address: organization.address,
                        address_en: organization.address_en,
                        telephone:organization.tel,
                        fax:organization.fax,
                        email: organization.email,
                        website: organization.website,
                        system_logo: organization.system_logo,
                        reports_logo: organization.reports_logo,

                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if (this.oldData && this.newData) {
            this.organization = this.newData;
            this.form.patchValue({
                id: this.newData.id,
                name: this.newData.name,
                name_en: this.newData.name_en,
                vat_sts: this.newData.vat_sts,
                def_org: this.newData.def_org+'',
                tax_number: this.newData.tax_number,
                main_currency: this.newData.main_currency,
                address: this.newData.address,
                address_en: this.newData.address_en,
                telephone: this.newData.tel,
                fax: this.newData.fax,
                email: this.newData.email,
                website: this.newData.website,
                system_logo: this.newData.system_logo,
                reports_logo: this.newData.reports_logo,

            });
        }
    }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if (userRoles.indexOf('setting.organization.' + role) >= 0) {
            return true;
        }
        return false;
    }

    deleteOrganization(organization: Organization) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if (organization) {
                    this.organizationService.delete(organization.id).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Delete completed')
                            });
                            setTimeout(()=>{
                                this.router.navigate(['/organization']);
                        },1000);
                            localStorage.setItem('showMessages', JSON.stringify(this.msgs));

                        }
                    );
                }
            }
        });
    }

    recoverEdit(organization: Organization) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (organization) {
                    this.organizationService.update(organization).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/organization/show', organization.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.organizationService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted organization recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/organization/list']);
                        }
                    );
                }
            }
        });
    }


  showattachement(row_id: string) {

    if (row_id) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          // this.changePicUrl();
          return true;
        }
      };
      const modalRef = this.modalService.open(AppArcComponent, options);
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.screenName = this.modelName;
    }
  }
  showHistory(row_id: string) {
    if (row_id) {
      const modalRef = this.modalService.open(AppLogComponent);
        modalRef.componentInstance.refShow = OrganizationShowComponent;

        modalRef.componentInstance.rowId = row_id;
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/views/setting/organization/organization-show/organization-show.component.ts